import * as types from 'constants/autenticacion.ActionTypes';
import * as services from 'services/autenticacion.service';

export const getTokenAutenticacion = (dataUser) => async (dispatch) => {
  dispatch({ type: types.GET_AUTENTICACION_LOADING });
  try {
    const request = {
      usuario: dataUser.usuario,
      password: dataUser.password,
      ip: dataUser.ipAddress,
      tokenCaptcha: dataUser.captcha
    };
    const { data } = await services.getAuthentication(request);
    const payload = data.token;
    dispatch({ type: types.GET_AUTENTICACION_SUCCESS, payload });
    return { success: true, response: { token: data.token, menuSistemas: data.menuSistemas } };
  } catch (error) {
    dispatch({ type: types.GET_AUTENTICACION_FAILURE, error });
    return { success: false, response: { error } };
  }
};

export const getEstadosAutenticacion = () => async (dispatch) => {
  dispatch({ type: types.GET_ESTADOS_LOADING });
  try {
    const { data } = await services.getEstados({});
    const payload = data.estados;
    dispatch({ type: types.GET_ESTADOS_SUCCESS, payload });
    return { success: true };
  } catch (error) {
    dispatch({ type: types.GET_ESTADOS_FAILURE, error });
    return { success: false };
  }
};

export const getIndicadoresAutenticacion = (idEstado) => async (dispatch) => {
  dispatch({ type: types.GET_INDICADORES_LOADING });
  try {
    const request = {
      idEstado
    };
    const { data } = await services.getIndicadores(request);
    const payload = data;
    dispatch({ type: types.GET_INDICADORES_SUCCESS, payload });
    return {
      success: true,
      response: { ultimaFecha: data.fechaUltimaActualizacion, indicadores: data.indicadores }
    };
  } catch (error) {
    dispatch({ type: types.GET_INDICADORES_FAILURE, error });
    return { success: false };
  }
};

export const getCaptchaAutenticacion = () => async (dispatch) => {
  dispatch({ type: types.GET_CAPTCHA_LOADING });
  try {
    const { data } = await services.getActiveCaptcha({});
    const payload = data.activo;
    dispatch({ type: types.GET_CAPTCHA_SUCCESS, payload });
    return { success: true };
  } catch (error) {
    dispatch({ type: types.GET_CAPTCHA_FAILURE, error });
    return { success: false };
  }
};

export const getMenuSistemasWeb = () => async (dispatch) => {
  dispatch({ type: types.GET_MENU_SISTEMAS_LOADING });
  try {
    const { data } = await services.getMenuSistemas();
    const payload = data.menuSistemas;
    dispatch({ type: types.GET_MENU_SISTEMAS_SUCCESS, payload });
    return { success: true };
  } catch (error) {
    dispatch({ type: types.GET_MENU_SISTEMAS_FAILURE, error });
    return { success: false };
  }
};

export const getCerrarSesionWeb = (sesionId) => async (dispatch) => {
  dispatch({ type: types.GET_CERRAR_SESION_LOADING });
  try {
    const { data } = await services.getCerrarSesion({ idSesion: sesionId });
    const payload = data;
    dispatch({ type: types.GET_CERRAR_SESION_SUCCESS, payload });
    return { success: true };
  } catch (error) {
    dispatch({ type: types.GET_CERRAR_SESION_FAILURE, error });
    return { success: false };
  }
};
